module.exports = "/build/web/images/team/pec-stadium.2673949f812c28313eed302ab6ce5abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/team/pec-stadium.jpg
// module id = 140
// module chunks = 24